module.exports = __webpack_public_path__ + "img/verified-visa.b7ccbf11.png";